module.exports = __webpack_public_path__ + "static/media/dodawanie_w_zakresie_20_rozpisywanie.7269474f.pdf";